import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWhatsappIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M242.813 205.474a15 15 0 0 0-15 15 15 15 0 0 0 15 15 15 15 0 0 0 15-15 15 15 0 0 0-15-15m.04 5.203a9.64 9.64 0 0 1 6.868 2.848 9.65 9.65 0 0 1 2.841 6.869c-.002 5.353-4.357 9.709-9.709 9.709h-.004a9.7 9.7 0 0 1-4.64-1.182l-5.147 1.35 1.377-5.031a9.7 9.7 0 0 1-1.297-4.854c.002-5.353 4.36-9.709 9.711-9.709m.002 1.64c-4.451 0-8.07 3.62-8.072 8.069 0 1.525.425 3.01 1.233 4.295l.193.305-.816 2.978 3.054-.8.295.175a8.06 8.06 0 0 0 4.108 1.123h.004c4.448 0 8.068-3.62 8.07-8.07a8.02 8.02 0 0 0-2.361-5.71 8.02 8.02 0 0 0-5.707-2.364m-3.439 3.587c.162 0 .323 0 .465.008.148.008.348-.057.545.416.202.485.687 1.68.748 1.802s.1.262.02.424c-.082.162-.121.263-.243.405-.121.141-.254.316-.363.425-.121.12-.247.251-.106.494s.629 1.039 1.35 1.682c.927.826 1.709 1.082 1.951 1.203.243.122.384.102.526-.06.141-.162.606-.709.767-.952s.323-.202.545-.12c.223.08 1.416.667 1.658.788v.002c.243.122.405.183.465.284s.062.585-.14 1.152c-.203.567-1.173 1.084-1.64 1.154-.417.063-.945.09-1.526-.095a14 14 0 0 1-1.383-.512c-2.434-1.051-4.023-3.502-4.145-3.664s-.99-1.316-.99-2.51.625-1.78.848-2.023a.9.9 0 0 1 .648-.303z" style={{
      fill: "currentColor",
      fillOpacity: 1,
      strokeWidth: 2.595,
      strokeLinecap: "square"
    }} transform="translate(-227.813 -205.474)" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgWhatsappIcon;